import React from 'react'

import Section from '../../shared/settings/section'
import Rentals from './rentals'
import { TESTERS } from '../../../lib/tester-classnames'

function MyActivity() {
  return (
    <Section title="Rentals" testerClassName={TESTERS.ACCOUNT.RENTALS}>
      <Rentals />
    </Section>
  )
}

export default MyActivity
